const CONTATO_FORA_DA_PLATAFORMA = 'CONTATO_FORA_DA_PLATAFORMA';
const OFENSA_AO_CLIENTE = 'OFENSA_AO_CLIENTE';
const NEGOCIACAO_FORA_DA_PLATAFORMA = 'NEGOCIACAO_FORA_DA_PLATAFORMA';
const TELEFONE_NO_TEXTO = 'TELEFONE_NO_TEXTO';
const EMAIL_NO_TEXTO = 'EMAIL_NO_TEXTO';
const NOME_DO_PROFISSIONAL = 'NOME_DO_PROFISSIONAL';

const CONTACT_DATA_IN_TEXT = {
    title: 'A mensagem contém dados de contato',
    action: 'Telefone, e-mail e assinatura precisam ser removidos. Dados do caso, como número do processo e valores da ação, podem permanecer.',
};

const CONTACT_OFF_PLATFORM = {
    title: 'A mensagem direciona o contato para fora da plataforma',
    action: 'O atendimento ao cliente acontece aqui, onde fica registrado no caso. Alinhar o serviço pelo chat é permitido; direcionar para outro canal, não.',
};

const DISRESPECTFUL_TONE = {
    title: 'O tom pode ser lido como desrespeitoso',
    action: 'Reescreva em tom neutro. Discordar do cliente ou recusar um pedido é permitido; ofender, não.',
};

const NEGOTIATION_OFF_PLATFORM = {
    title: 'A mensagem trata de negociação fora da plataforma',
    action: 'Preço, prazo e contratação são ajustados pela plataforma, não pelo chat.',
};

const REASON_MESSAGES = {
    [TELEFONE_NO_TEXTO]: CONTACT_DATA_IN_TEXT,
    [EMAIL_NO_TEXTO]: CONTACT_DATA_IN_TEXT,
    [NOME_DO_PROFISSIONAL]: CONTACT_DATA_IN_TEXT,
    [CONTATO_FORA_DA_PLATAFORMA]: CONTACT_OFF_PLATFORM,
    [OFENSA_AO_CLIENTE]: DISRESPECTFUL_TONE,
    [NEGOCIACAO_FORA_DA_PLATAFORMA]: NEGOTIATION_OFF_PLATFORM,
};

const UNKNOWN_REASON_MESSAGE = {
    title: 'A mensagem não pôde ser liberada',
    action: 'Revise o texto e tente novamente. Se persistir, entre em contato com o suporte.',
};

export const blockMessageFor = (reason) => REASON_MESSAGES[reason] || UNKNOWN_REASON_MESSAGE;

export const reasons = {
    CONTATO_FORA_DA_PLATAFORMA,
    OFENSA_AO_CLIENTE,
    NEGOCIACAO_FORA_DA_PLATAFORMA,
    TELEFONE_NO_TEXTO,
    EMAIL_NO_TEXTO,
    NOME_DO_PROFISSIONAL,
};
